import { render, staticRenderFns } from "./manageOrder.vue?vue&type=template&id=506cbf54"
import script from "./manageOrder.vue?vue&type=script&lang=js"
export * from "./manageOrder.vue?vue&type=script&lang=js"
import style0 from "./manageOrder.vue?vue&type=style&index=0&id=506cbf54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports